import { z } from 'zod';
/** A user's clock preference (uiv2 BE5, SET-10): `auto` lets the language decide. */
export const TIME_FORMATS = ['auto', '12h', '24h'];
/**
 * `PATCH /auth/me` — a user edits their OWN name, email (uiv2 D5, SET-08) and
 * clock preference (uiv2 BE5, SET-10).
 * Strict: a username (editable by nobody) or any other key is refused rather
 * than stripped, so a mismatched client gets a 400, not a 200 that saved
 * nothing. An email change also needs the current password (X-Confirm-Password).
 */
export const updateProfileSchema = z
    .object({
    fullName: z.string().trim().min(2).max(100).optional(),
    email: z.string().trim().toLowerCase().email().max(255).optional(),
    timeFormat: z.enum(TIME_FORMATS).optional(),
})
    .strict()
    .refine((v) => v.fullName !== undefined || v.email !== undefined || v.timeFormat !== undefined, { message: 'Nothing to update' });
//# sourceMappingURL=profile.js.map